import { render } from "./joinProxy.vue?vue&type=template&id=4a033835&scoped=true"
import script from "./joinProxy.vue?vue&type=script&lang=js"
export * from "./joinProxy.vue?vue&type=script&lang=js"

import "./joinProxy.vue?vue&type=style&index=0&id=4a033835&lang=scss&scoped=true"
import "./joinProxy.vue?vue&type=style&index=1&id=4a033835&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a033835"]])

export default __exports__